import Vue from 'vue';
import {
    AxiosRequestConfig,
    AxiosError,
    AxiosResponse,
    AxiosInstance,
    InternalAxiosRequestConfig
} from 'axios';
import {VueRouter} from 'vue-router/types/router';
import {getSlug} from "@/router";

const onRequest = async (config: AxiosRequestConfig|any): Promise<InternalAxiosRequestConfig> => {
    config.withCredentials = true;
    return config;
};

const onRequestError = (error: AxiosError) => Promise.reject(error);

const onResponse = (response: AxiosResponse) => response;

const onResponseError = async (error: AxiosError) => {
    if (error.response) {
    // Access Token was expired
        if (
            error.response.status === 401
        ) {
            const baseUrl = `/${Vue.prototype.$language}-${Vue.prototype.$country}`;
            window.location.href = `${baseUrl}/${getSlug(Vue.prototype.$language, Vue.prototype.$country, 'login', true)}?redirectTo=${window.location.pathname}`
            return Promise.reject(error);
        }
    }
    return Promise.reject(error);
};

const setupInterceptorsTo = (
    axiosInstance: AxiosInstance,
    router?: VueRouter,
) => {
    axiosInstance.interceptors.request.use(onRequest, onRequestError);
    axiosInstance.interceptors.response.use((r) => onResponse(r), (r) => onResponseError(r));
    return axiosInstance;
};

export default setupInterceptorsTo;
